import { createAction } from 'redux-actions';

export const GET_INVOICE_REQUEST = createAction('GET_INVOICE_REQUEST');
export const GET_INVOICE_SUCCESS = createAction('GET_INVOICE_SUCCESS');
export const GET_INVOICE_FAILURE = createAction('GET_INVOICE_FAILURE');
